import {callAPI} from "@betrue/shared/utils";
import {ExperienceLevel, Profile, ProfileApi, Skill} from "@betrue/shared/interfaces";

class ProfileClient implements ProfileApi {
  updateProfileRating(rating: 0 | 1 | 2 | 3 | 4 | 5, profileId: string) {
      throw new Error("Method not implemented.");
  }

  addSkillToProfile(s: Skill, profileId: string) {
      throw new Error("Method not implemented.");
  }
  removeSkillFromProfile(s: Skill, profileId: string) {
      throw new Error("Method not implemented.");
  }
  addJobToProfile(jobId: string, profileId: string) {
      throw new Error("Method not implemented.");
  }
  removeJobFromProfile(profileId: string) {
      throw new Error("Method not implemented.");
  }
  getProfileById(id: string) {
      throw new Error("Method not implemented.");
  }
  removeProfileSkill(s: Skill, profileId: string) {
      throw new Error("Method not implemented.");
  }
  updateProfileSkill(s: Skill, profileId: string, xp: ExperienceLevel) {
      throw new Error("Method not implemented.");
  }

  getById(id: string){
    return callAPI<Profile>(`users/${id}`);
  }


  createProfile(Profile) {
    return Promise.resolve(undefined);
  }

  updateProfile(p: Profile) {
  }

  addProfileSkill(s: Skill) {
  }



  addJob(Job, profileId) {
  }

  removeJob(profileId) {
  }

  getAllProfiles() {
  }

  getPublicProfiles() {
  }

  updatePublicState(profileId: string, isPublishable: boolean) {
  }
}

export const profileClient = new ProfileClient()
